import React from 'react';
import ComingSoon from './ComingSoon';
import { extractLeadingNumber } from '@src/utils/utils';

function getPercentColor(value) {
  const hue = (value * 120).toString(10);
  return `hsl(${hue},100%,50%)`;
}

function getChapterColor(value) {
  const normalizedValue = Math.max(0, Math.min(14, value)) / 14;
  const basePink = { r: 253, g: 153, b: 197 };

  const minBrightness = 0.7;
  const maxBrightness = 1;
  const brightness = minBrightness + normalizedValue * (maxBrightness - minBrightness);

  const r = Math.round(basePink.r * brightness);
  const g = Math.round(basePink.g * brightness);
  const b = Math.round(basePink.b * brightness);

  return `rgb(${r}, ${g}, ${b})`;
}

const Number = ({ block }) => {
  const { value, displayAs } = block;

  if (!value && value !== 0) {
    return <ComingSoon />;
  }

  if (displayAs === 'chapter') {
    const chapterNumber = extractLeadingNumber(value);

    return (
      <div
        className="chapter"
        style={{
          backgroundColor: value === 0 ? 'black' : getChapterColor(chapterNumber),
          color: value === 0 ? 'white' : 'black',
        }}
      >
        {value}
      </div>
    );
  }

  if (displayAs === 'grade') {
    return <div className={`grade grade-${value}`}>{value}</div>;
  }

  if (displayAs === 'percent') {
    const decimal = (value / 100).toFixed(2);

    return (
      <div
        className="percentage"
        style={{
          backgroundColor: decimal === '0.00' ? 'black' : getPercentColor(decimal),
          color: decimal === '0.00' ? 'white' : 'black',
          width: 'fit-content',
          padding: '0 5px',
        }}
      >
        {value}%
      </div>
    );
  }

  return null;
};

export default Number;
